export const manifest = {
  screens: {
    scr_2py5pk: { name: "Home", route: "/", position: {"x":0,"y":0}, isDefaultRow: true },
    scr_pxnlxv: { name: "Privacy Policy", route: "/privacy", position: {"x":1400,"y":0}, isDefaultRow: true },
  },
}
